var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"title":_vm.$t('Invite Friends'),"hide-footer":"","centered":"","no-close-on-esc":"","static":""},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('invite-friends-modal')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }